import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { AddManagerCommentAmountExpenseType } from "../../../domain/models/expense-dashboard/add-manager-comment-amount-expense";
import { RemoteAddManagerCommentAmountExpense } from "../../../data/usecases/expense-dashboard/remote-add-manager-comment-amount-expense";

export interface AddManagerCommentAmountExpenseInterface {
  AddManagerCommentAmountExpenseState: FetchState;
  addManagerCommentAmountExpense: Function;
}

const initialStates = {
  AddManagerCommentAmountExpenseState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useAddManagerCommentAmountExpenseStateSlice: StateCreator<
  AddManagerCommentAmountExpenseInterface
> = (set, get) => ({
  ...initialStates,
  addManagerCommentAmountExpense: async (
    payload: AddManagerCommentAmountExpenseType
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddManagerCommentAmountExpense =
      new RemoteAddManagerCommentAmountExpense(
        `${BASE_URL}${Endpoints.ADD_MANAGER_COMMENT_AMOUNT_EXPENSE_REPORT}`,
        axiosHttpClient
      );

    let result = await remoteAddManagerCommentAmountExpense.update(payload);
    return result;
  },
});
